import { render } from "./CollectionDetail.vue?vue&type=template&id=a8b3e408&scoped=true&ts=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=ts"
export * from "./CollectionDetail.vue?vue&type=script&lang=ts"

import "./CollectionDetail.vue?vue&type=style&index=0&id=a8b3e408&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b3e408"]])

export default __exports__